(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.modal = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  var dialogPolyfill = createCommonjsModule(function (module) {
    (function () {
      // nb. This is for IE10 and lower _only_.
      var supportCustomEvent = window.CustomEvent;

      if (!supportCustomEvent || _typeof(supportCustomEvent) === 'object') {
        supportCustomEvent = function CustomEvent(event, x) {
          x = x || {};
          var ev = document.createEvent('CustomEvent');
          ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
          return ev;
        };

        supportCustomEvent.prototype = window.Event.prototype;
      }
      /**
       * @param {Element} el to check for stacking context
       * @return {boolean} whether this el or its parents creates a stacking context
       */


      function createsStackingContext(el) {
        while (el && el !== document.body) {
          var s = window.getComputedStyle(el);

          var invalid = function invalid(k, ok) {
            return !(s[k] === undefined || s[k] === ok);
          };

          if (s.opacity < 1 || invalid('zIndex', 'auto') || invalid('transform', 'none') || invalid('mixBlendMode', 'normal') || invalid('filter', 'none') || invalid('perspective', 'none') || s['isolation'] === 'isolate' || s.position === 'fixed' || s.webkitOverflowScrolling === 'touch') {
            return true;
          }

          el = el.parentElement;
        }

        return false;
      }
      /**
       * Finds the nearest <dialog> from the passed element.
       *
       * @param {Element} el to search from
       * @return {HTMLDialogElement} dialog found
       */


      function findNearestDialog(el) {
        while (el) {
          if (el.localName === 'dialog') {
            return (
              /** @type {HTMLDialogElement} */
              el
            );
          }

          el = el.parentElement;
        }

        return null;
      }
      /**
       * Blur the specified element, as long as it's not the HTML body element.
       * This works around an IE9/10 bug - blurring the body causes Windows to
       * blur the whole application.
       *
       * @param {Element} el to blur
       */


      function safeBlur(el) {
        if (el && el.blur && el !== document.body) {
          el.blur();
        }
      }
      /**
       * @param {!NodeList} nodeList to search
       * @param {Node} node to find
       * @return {boolean} whether node is inside nodeList
       */


      function inNodeList(nodeList, node) {
        for (var i = 0; i < nodeList.length; ++i) {
          if (nodeList[i] === node) {
            return true;
          }
        }

        return false;
      }
      /**
       * @param {HTMLFormElement} el to check
       * @return {boolean} whether this form has method="dialog"
       */


      function isFormMethodDialog(el) {
        if (!el || !el.hasAttribute('method')) {
          return false;
        }

        return el.getAttribute('method').toLowerCase() === 'dialog';
      }
      /**
       * @param {!HTMLDialogElement} dialog to upgrade
       * @constructor
       */


      function dialogPolyfillInfo(dialog) {
        this.dialog_ = dialog;
        this.replacedStyleTop_ = false;
        this.openAsModal_ = false; // Set a11y role. Browsers that support dialog implicitly know this already.

        if (!dialog.hasAttribute('role')) {
          dialog.setAttribute('role', 'dialog');
        }

        dialog.show = this.show.bind(this);
        dialog.showModal = this.showModal.bind(this);
        dialog.close = this.close.bind(this);

        if (!('returnValue' in dialog)) {
          dialog.returnValue = '';
        }

        if ('MutationObserver' in window) {
          var mo = new MutationObserver(this.maybeHideModal.bind(this));
          mo.observe(dialog, {
            attributes: true,
            attributeFilter: ['open']
          });
        } else {
          // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
          // seem to fire even if the element was removed as part of a parent removal. Use the removed
          // events to force downgrade (useful if removed/immediately added).
          var removed = false;

          var cb = function () {
            removed ? this.downgradeModal() : this.maybeHideModal();
            removed = false;
          }.bind(this);

          var timeout;

          var delayModel = function delayModel(ev) {
            if (ev.target !== dialog) {
              return;
            } // not for a child element


            var cand = 'DOMNodeRemoved';
            removed |= ev.type.substr(0, cand.length) === cand;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(cb, 0);
          };

          ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function (name) {
            dialog.addEventListener(name, delayModel);
          });
        } // Note that the DOM is observed inside DialogManager while any dialog
        // is being displayed as a modal, to catch modal removal from the DOM.


        Object.defineProperty(dialog, 'open', {
          set: this.setOpen.bind(this),
          get: dialog.hasAttribute.bind(dialog, 'open')
        });
        this.backdrop_ = document.createElement('div');
        this.backdrop_.className = 'backdrop';
        this.backdrop_.addEventListener('click', this.backdropClick_.bind(this));
      }

      dialogPolyfillInfo.prototype = {
        get dialog() {
          return this.dialog_;
        },

        /**
         * Maybe remove this dialog from the modal top layer. This is called when
         * a modal dialog may no longer be tenable, e.g., when the dialog is no
         * longer open or is no longer part of the DOM.
         */
        maybeHideModal: function maybeHideModal() {
          if (this.dialog_.hasAttribute('open') && document.body.contains(this.dialog_)) {
            return;
          }

          this.downgradeModal();
        },

        /**
         * Remove this dialog from the modal top layer, leaving it as a non-modal.
         */
        downgradeModal: function downgradeModal() {
          if (!this.openAsModal_) {
            return;
          }

          this.openAsModal_ = false;
          this.dialog_.style.zIndex = ''; // This won't match the native <dialog> exactly because if the user set top on a centered
          // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
          // possible to polyfill this perfectly.

          if (this.replacedStyleTop_) {
            this.dialog_.style.top = '';
            this.replacedStyleTop_ = false;
          } // Clear the backdrop and remove from the manager.


          this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
          dialogPolyfill.dm.removeDialog(this);
        },

        /**
         * @param {boolean} value whether to open or close this dialog
         */
        setOpen: function setOpen(value) {
          if (value) {
            this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
          } else {
            this.dialog_.removeAttribute('open');
            this.maybeHideModal(); // nb. redundant with MutationObserver
          }
        },

        /**
         * Handles clicks on the fake .backdrop element, redirecting them as if
         * they were on the dialog itself.
         *
         * @param {!Event} e to redirect
         */
        backdropClick_: function backdropClick_(e) {
          if (!this.dialog_.hasAttribute('tabindex')) {
            // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
            // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
            // would not be needed - clicks would move the implicit cursor there.
            var fake = document.createElement('div');
            this.dialog_.insertBefore(fake, this.dialog_.firstChild);
            fake.tabIndex = -1;
            fake.focus();
            this.dialog_.removeChild(fake);
          } else {
            this.dialog_.focus();
          }

          var redirectedEvent = document.createEvent('MouseEvents');
          redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
          this.dialog_.dispatchEvent(redirectedEvent);
          e.stopPropagation();
        },

        /**
         * Focuses on the first focusable element within the dialog. This will always blur the current
         * focus, even if nothing within the dialog is found.
         */
        focus_: function focus_() {
          // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
          var target = this.dialog_.querySelector('[autofocus]:not([disabled])');

          if (!target && this.dialog_.tabIndex >= 0) {
            target = this.dialog_;
          }

          if (!target) {
            // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
            // alternative involves stepping through and trying to focus everything.
            var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
            var query = opts.map(function (el) {
              return el + ':not([disabled])';
            }); // TODO(samthor): tabindex values that are not numeric are not focusable.

            query.push('[tabindex]:not([disabled]):not([tabindex=""])'); // tabindex != "", not disabled

            target = this.dialog_.querySelector(query.join(', '));
          }

          safeBlur(document.activeElement);
          target && target.focus();
        },

        /**
         * Sets the zIndex for the backdrop and dialog.
         *
         * @param {number} dialogZ
         * @param {number} backdropZ
         */
        updateZIndex: function updateZIndex(dialogZ, backdropZ) {
          if (dialogZ < backdropZ) {
            throw new Error('dialogZ should never be < backdropZ');
          }

          this.dialog_.style.zIndex = dialogZ;
          this.backdrop_.style.zIndex = backdropZ;
        },

        /**
         * Shows the dialog. If the dialog is already open, this does nothing.
         */
        show: function show() {
          if (!this.dialog_.open) {
            this.setOpen(true);
            this.focus_();
          }
        },

        /**
         * Show this dialog modally.
         */
        showModal: function showModal() {
          if (this.dialog_.hasAttribute('open')) {
            throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
          }

          if (!document.body.contains(this.dialog_)) {
            throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
          }

          if (!dialogPolyfill.dm.pushDialog(this)) {
            throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
          }

          if (createsStackingContext(this.dialog_.parentElement)) {
            console.warn('A dialog is being shown inside a stacking context. ' + 'This may cause it to be unusable. For more information, see this link: ' + 'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
          }

          this.setOpen(true);
          this.openAsModal_ = true; // Optionally center vertically, relative to the current viewport.

          if (dialogPolyfill.needsCentering(this.dialog_)) {
            dialogPolyfill.reposition(this.dialog_);
            this.replacedStyleTop_ = true;
          } else {
            this.replacedStyleTop_ = false;
          } // Insert backdrop.


          this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling); // Focus on whatever inside the dialog.

          this.focus_();
        },

        /**
         * Closes this HTMLDialogElement. This is optional vs clearing the open
         * attribute, however this fires a 'close' event.
         *
         * @param {string=} opt_returnValue to use as the returnValue
         */
        close: function close(opt_returnValue) {
          if (!this.dialog_.hasAttribute('open')) {
            throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
          }

          this.setOpen(false); // Leave returnValue untouched in case it was set directly on the element

          if (opt_returnValue !== undefined) {
            this.dialog_.returnValue = opt_returnValue;
          } // Triggering "close" event for any attached listeners on the <dialog>.


          var closeEvent = new supportCustomEvent('close', {
            bubbles: false,
            cancelable: false
          });
          this.dialog_.dispatchEvent(closeEvent);
        }
      };
      var dialogPolyfill = {};

      dialogPolyfill.reposition = function (element) {
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
        element.style.top = Math.max(scrollTop, topValue) + 'px';
      };

      dialogPolyfill.isInlinePositionSetByStylesheet = function (element) {
        for (var i = 0; i < document.styleSheets.length; ++i) {
          var styleSheet = document.styleSheets[i];
          var cssRules = null; // Some browsers throw on cssRules.

          try {
            cssRules = styleSheet.cssRules;
          } catch (e) {}

          if (!cssRules) {
            continue;
          }

          for (var j = 0; j < cssRules.length; ++j) {
            var rule = cssRules[j];
            var selectedNodes = null; // Ignore errors on invalid selector texts.

            try {
              selectedNodes = document.querySelectorAll(rule.selectorText);
            } catch (e) {}

            if (!selectedNodes || !inNodeList(selectedNodes, element)) {
              continue;
            }

            var cssTop = rule.style.getPropertyValue('top');
            var cssBottom = rule.style.getPropertyValue('bottom');

            if (cssTop && cssTop !== 'auto' || cssBottom && cssBottom !== 'auto') {
              return true;
            }
          }
        }

        return false;
      };

      dialogPolyfill.needsCentering = function (dialog) {
        var computedStyle = window.getComputedStyle(dialog);

        if (computedStyle.position !== 'absolute') {
          return false;
        } // We must determine whether the top/bottom specified value is non-auto.  In
        // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
        // Firefox returns the used value. So we do this crazy thing instead: check
        // the inline style and then go through CSS rules.


        if (dialog.style.top !== 'auto' && dialog.style.top !== '' || dialog.style.bottom !== 'auto' && dialog.style.bottom !== '') {
          return false;
        }

        return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
      };
      /**
       * @param {!Element} element to force upgrade
       */


      dialogPolyfill.forceRegisterDialog = function (element) {
        if (window.HTMLDialogElement || element.showModal) {
          console.warn('This browser already supports <dialog>, the polyfill ' + 'may not work correctly', element);
        }

        if (element.localName !== 'dialog') {
          throw new Error('Failed to register dialog: The element is not a dialog.');
        }

        new dialogPolyfillInfo(
        /** @type {!HTMLDialogElement} */
        element);
      };
      /**
       * @param {!Element} element to upgrade, if necessary
       */


      dialogPolyfill.registerDialog = function (element) {
        if (!element.showModal) {
          dialogPolyfill.forceRegisterDialog(element);
        }
      };
      /**
       * @constructor
       */


      dialogPolyfill.DialogManager = function () {
        /** @type {!Array<!dialogPolyfillInfo>} */
        this.pendingDialogStack = [];
        var checkDOM = this.checkDOM_.bind(this); // The overlay is used to simulate how a modal dialog blocks the document.
        // The blocking dialog is positioned on top of the overlay, and the rest of
        // the dialogs on the pending dialog stack are positioned below it. In the
        // actual implementation, the modal dialog stacking is controlled by the
        // top layer, where z-index has no effect.

        this.overlay = document.createElement('div');
        this.overlay.className = '_dialog_overlay';
        this.overlay.addEventListener('click', function (e) {
          this.forwardTab_ = undefined;
          e.stopPropagation();
          checkDOM([]); // sanity-check DOM
        }.bind(this));
        this.handleKey_ = this.handleKey_.bind(this);
        this.handleFocus_ = this.handleFocus_.bind(this);
        this.zIndexLow_ = 100000;
        this.zIndexHigh_ = 100000 + 150;
        this.forwardTab_ = undefined;

        if ('MutationObserver' in window) {
          this.mo_ = new MutationObserver(function (records) {
            var removed = [];
            records.forEach(function (rec) {
              for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
                if (!(c instanceof Element)) {
                  continue;
                } else if (c.localName === 'dialog') {
                  removed.push(c);
                }

                removed = removed.concat(c.querySelectorAll('dialog'));
              }
            });
            removed.length && checkDOM(removed);
          });
        }
      };
      /**
       * Called on the first modal dialog being shown. Adds the overlay and related
       * handlers.
       */


      dialogPolyfill.DialogManager.prototype.blockDocument = function () {
        document.documentElement.addEventListener('focus', this.handleFocus_, true);
        document.addEventListener('keydown', this.handleKey_);
        this.mo_ && this.mo_.observe(document, {
          childList: true,
          subtree: true
        });
      };
      /**
       * Called on the first modal dialog being removed, i.e., when no more modal
       * dialogs are visible.
       */


      dialogPolyfill.DialogManager.prototype.unblockDocument = function () {
        document.documentElement.removeEventListener('focus', this.handleFocus_, true);
        document.removeEventListener('keydown', this.handleKey_);
        this.mo_ && this.mo_.disconnect();
      };
      /**
       * Updates the stacking of all known dialogs.
       */


      dialogPolyfill.DialogManager.prototype.updateStacking = function () {
        var zIndex = this.zIndexHigh_;

        for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
          dpi.updateZIndex(--zIndex, --zIndex);

          if (i === 0) {
            this.overlay.style.zIndex = --zIndex;
          }
        } // Make the overlay a sibling of the dialog itself.


        var last = this.pendingDialogStack[0];

        if (last) {
          var p = last.dialog.parentNode || document.body;
          p.appendChild(this.overlay);
        } else if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
        }
      };
      /**
       * @param {Element} candidate to check if contained or is the top-most modal dialog
       * @return {boolean} whether candidate is contained in top dialog
       */


      dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function (candidate) {
        while (candidate = findNearestDialog(candidate)) {
          for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
            if (dpi.dialog === candidate) {
              return i === 0; // only valid if top-most
            }
          }

          candidate = candidate.parentElement;
        }

        return false;
      };

      dialogPolyfill.DialogManager.prototype.handleFocus_ = function (event) {
        if (this.containedByTopDialog_(event.target)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        safeBlur(
        /** @type {Element} */
        event.target);

        if (this.forwardTab_ === undefined) {
          return;
        } // move focus only from a tab key


        var dpi = this.pendingDialogStack[0];
        var dialog = dpi.dialog;
        var position = dialog.compareDocumentPosition(event.target);

        if (position & Node.DOCUMENT_POSITION_PRECEDING) {
          if (this.forwardTab_) {
            // forward
            dpi.focus_();
          } else {
            // backwards
            document.documentElement.focus();
          }
        }

        return false;
      };

      dialogPolyfill.DialogManager.prototype.handleKey_ = function (event) {
        this.forwardTab_ = undefined;

        if (event.keyCode === 27) {
          event.preventDefault();
          event.stopPropagation();
          var cancelEvent = new supportCustomEvent('cancel', {
            bubbles: false,
            cancelable: true
          });
          var dpi = this.pendingDialogStack[0];

          if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) {
            dpi.dialog.close();
          }
        } else if (event.keyCode === 9) {
          this.forwardTab_ = !event.shiftKey;
        }
      };
      /**
       * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
       * removed and immediately readded don't stay modal, they become normal.
       *
       * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
       */


      dialogPolyfill.DialogManager.prototype.checkDOM_ = function (removed) {
        // This operates on a clone because it may cause it to change. Each change also calls
        // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
        // at a time?!
        var clone = this.pendingDialogStack.slice();
        clone.forEach(function (dpi) {
          if (removed.indexOf(dpi.dialog) !== -1) {
            dpi.downgradeModal();
          } else {
            dpi.maybeHideModal();
          }
        });
      };
      /**
       * @param {!dialogPolyfillInfo} dpi
       * @return {boolean} whether the dialog was allowed
       */


      dialogPolyfill.DialogManager.prototype.pushDialog = function (dpi) {
        var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;

        if (this.pendingDialogStack.length >= allowed) {
          return false;
        }

        if (this.pendingDialogStack.unshift(dpi) === 1) {
          this.blockDocument();
        }

        this.updateStacking();
        return true;
      };
      /**
       * @param {!dialogPolyfillInfo} dpi
       */


      dialogPolyfill.DialogManager.prototype.removeDialog = function (dpi) {
        var index = this.pendingDialogStack.indexOf(dpi);

        if (index === -1) {
          return;
        }

        this.pendingDialogStack.splice(index, 1);

        if (this.pendingDialogStack.length === 0) {
          this.unblockDocument();
        }

        this.updateStacking();
      };

      dialogPolyfill.dm = new dialogPolyfill.DialogManager();
      dialogPolyfill.formSubmitter = null;
      dialogPolyfill.useValue = null;
      /**
       * Installs global handlers, such as click listers and native method overrides. These are needed
       * even if a no dialog is registered, as they deal with <form method="dialog">.
       */

      if (window.HTMLDialogElement === undefined) {
        /**
         * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
         * one that returns the correct value.
         */
        var testForm = document.createElement('form');
        testForm.setAttribute('method', 'dialog');

        if (testForm.method !== 'dialog') {
          var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');

          if (methodDescriptor) {
            // nb. Some older iOS and older PhantomJS fail to return the descriptor. Don't do anything
            // and don't bother to update the element.
            var realGet = methodDescriptor.get;

            methodDescriptor.get = function () {
              if (isFormMethodDialog(this)) {
                return 'dialog';
              }

              return realGet.call(this);
            };

            var realSet = methodDescriptor.set;

            methodDescriptor.set = function (v) {
              if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
                return this.setAttribute('method', v);
              }

              return realSet.call(this, v);
            };

            Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
          }
        }
        /**
         * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
         * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
         * document.activeElement.
         */


        document.addEventListener('click', function (ev) {
          dialogPolyfill.formSubmitter = null;
          dialogPolyfill.useValue = null;

          if (ev.defaultPrevented) {
            return;
          } // e.g. a submit which prevents default submission


          var target =
          /** @type {Element} */
          ev.target;

          if (!target || !isFormMethodDialog(target.form)) {
            return;
          }

          var valid = target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1;

          if (!valid) {
            if (!(target.localName === 'input' && target.type === 'image')) {
              return;
            } // this is a <input type="image">, which can submit forms


            dialogPolyfill.useValue = ev.offsetX + ',' + ev.offsetY;
          }

          var dialog = findNearestDialog(target);

          if (!dialog) {
            return;
          }

          dialogPolyfill.formSubmitter = target;
        }, false);
        /**
         * Replace the native HTMLFormElement.submit() method, as it won't fire the
         * submit event and give us a chance to respond.
         */

        var nativeFormSubmit = HTMLFormElement.prototype.submit;

        var replacementFormSubmit = function replacementFormSubmit() {
          if (!isFormMethodDialog(this)) {
            return nativeFormSubmit.call(this);
          }

          var dialog = findNearestDialog(this);
          dialog && dialog.close();
        };

        HTMLFormElement.prototype.submit = replacementFormSubmit;
        /**
         * Global form 'dialog' method handler. Closes a dialog correctly on submit
         * and possibly sets its return value.
         */

        document.addEventListener('submit', function (ev) {
          var form =
          /** @type {HTMLFormElement} */
          ev.target;

          if (!isFormMethodDialog(form)) {
            return;
          }

          ev.preventDefault();
          var dialog = findNearestDialog(form);

          if (!dialog) {
            return;
          } // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
          // the submitter is correct before using its value as .returnValue.


          var s = dialogPolyfill.formSubmitter;

          if (s && s.form === form) {
            dialog.close(dialogPolyfill.useValue || s.value);
          } else {
            dialog.close();
          }

          dialogPolyfill.formSubmitter = null;
        }, true);
      }

      dialogPolyfill['forceRegisterDialog'] = dialogPolyfill.forceRegisterDialog;
      dialogPolyfill['registerDialog'] = dialogPolyfill.registerDialog;

      if (_typeof(module['exports']) === 'object') {
        // CommonJS support
        module['exports'] = dialogPolyfill;
      } else {
        // all others
        window['dialogPolyfill'] = dialogPolyfill;
      }
    })();
  });

  var toArray = function toArray(a) {
    var ret = Array(a.length);

    for (var i = 0; i < a.length; ++i) {
      ret[i] = a[i];
    }

    return ret;
  };

  var arrayFind = function arrayFind(array, search) {
    return array.filter(function (a) {
      return a === search;
    })[0];
  };

  var asArray = function asArray(a) {
    return Array.isArray(a) ? a : [a];
  };

  var tabSort = function tabSort(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;

    if (tabDiff) {
      if (!a.tabIndex) return 1;
      if (!b.tabIndex) return -1;
    }

    return tabDiff || indexDiff;
  };

  var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
    return toArray(nodes).map(function (node, index) {
      return {
        node: node,
        index: index,
        tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
      };
    }).filter(function (data) {
      return !filterNegative || data.tabIndex >= 0;
    }).sort(tabSort);
  };

  var tabbables = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];
  var FOCUS_GROUP = 'data-focus-lock';
  var FOCUS_DISABLED = 'data-focus-lock-disabled';
  var FOCUS_ALLOW = 'data-no-focus-lock';
  var FOCUS_AUTO = 'data-autofocus-inside';
  var queryTabbables = tabbables.join(',');
  var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

  var getFocusables = function getFocusables(parents, withGuards) {
    return parents.reduce(function (acc, parent) {
      return acc.concat( // add all tabbables inside
      toArray(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)), // add if node is tabble itself
      parent.parentNode ? toArray(parent.parentNode.querySelectorAll(tabbables.join(','))).filter(function (node) {
        return node === parent;
      }) : []);
    }, []);
  };

  var getParentAutofocusables = function getParentAutofocusables(parent) {
    var parentFocus = parent.querySelectorAll('[' + FOCUS_AUTO + ']');
    return toArray(parentFocus).map(function (node) {
      return getFocusables([node]);
    }).reduce(function (acc, nodes) {
      return acc.concat(nodes);
    }, []);
  };

  var isElementHidden = function isElementHidden(computedStyle) {
    if (!computedStyle || !computedStyle.getPropertyValue) {
      return false;
    }

    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
  };

  var isVisible = function isVisible(node) {
    return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
  };

  var notHiddenInput = function notHiddenInput(node) {
    return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
  };

  var getParents = function getParents(node) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    parents.push(node);

    if (node.parentNode) {
      getParents(node.parentNode, parents);
    }

    return parents;
  };

  var getCommonParent = function getCommonParent(nodea, nodeb) {
    var parentsA = getParents(nodea);
    var parentsB = getParents(nodeb);

    for (var i = 0; i < parentsA.length; i += 1) {
      var currentParent = parentsA[i];

      if (parentsB.indexOf(currentParent) >= 0) {
        return currentParent;
      }
    }

    return false;
  };

  var filterFocusable = function filterFocusable(nodes) {
    return toArray(nodes).filter(function (node) {
      return isVisible(node);
    }).filter(function (node) {
      return notHiddenInput(node);
    });
  };

  var getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards)), true, withGuards);
  };

  var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes)), false);
  };

  var parentAutofocusables = function parentAutofocusables(topNode) {
    return filterFocusable(getParentAutofocusables(topNode));
  };

  var isRadio = function isRadio(node) {
    return node.tagName === 'INPUT' && node.type === 'radio';
  };

  var findSelectedRadio = function findSelectedRadio(node, nodes) {
    return nodes.filter(isRadio).filter(function (el) {
      return el.name === node.name;
    }).filter(function (el) {
      return el.checked;
    })[0] || node;
  };

  var pickFirstFocus = function pickFirstFocus(nodes) {
    if (nodes[0] && nodes.length > 1) {
      if (isRadio(nodes[0]) && nodes[0].name) {
        return findSelectedRadio(nodes[0], nodes);
      }
    }

    return nodes[0];
  };

  var pickFocusable = function pickFocusable(nodes, index) {
    if (nodes.length > 1) {
      if (isRadio(nodes[index]) && nodes[index].name) {
        return nodes.indexOf(findSelectedRadio(nodes[index], nodes));
      }
    }

    return index;
  };

  var _typeof$1 = typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol" ? function (obj) {
    return _typeof(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
  };

  var filterNested = function filterNested(nodes) {
    var l = nodes.length;

    for (var i = 0; i < l; i += 1) {
      var _loop = function _loop(j) {
        if (i !== j) {
          if (nodes[i].contains(nodes[j])) {
            return {
              v: filterNested(nodes.filter(function (x) {
                return x !== nodes[j];
              }))
            };
          }
        }
      };

      for (var j = 0; j < l; j += 1) {
        var _ret = _loop(j);

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof$1(_ret)) === "object") return _ret.v;
      }
    }

    return nodes;
  };

  var getTopParent = function getTopParent(node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
  };

  var getAllAffectedNodes = function getAllAffectedNodes(node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
      var group = currentNode.getAttribute(FOCUS_GROUP);
      acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll('[' + FOCUS_GROUP + '="' + group + '"]:not([' + FOCUS_DISABLED + '="disabled"])'))) : [currentNode]);
      return acc;
    }, []);
  };

  var findAutoFocused = function findAutoFocused(autoFocusables) {
    return function (node) {
      return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
    };
  };

  var isGuard = function isGuard(node) {
    return node && node.dataset && node.dataset.focusGuard;
  };

  var notAGuard = function notAGuard(node) {
    return !isGuard(node);
  };

  var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement); // focus is inside

    if (innerNodes.indexOf(activeElement) >= 0) {
      return undefined;
    }

    var activeIndex = outerNodes.indexOf(activeElement);
    var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
    var lastNodeInside = innerNodes.indexOf(lastNode);
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var returnFirstNode = pickFocusable(innerNodes, 0);
    var returnLastNode = pickFocusable(innerNodes, cnt - 1); // new focus

    if (activeIndex === -1 || lastNodeInside === -1) {
      return innerNodes.indexOf(autoFocused && autoFocused.length ? pickFirstFocus(autoFocused) : pickFirstFocus(innerNodes));
    } // old focus


    if (!indexDiff && lastNodeInside >= 0) {
      return lastNodeInside;
    } // first element


    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
      return returnLastNode;
    } // last element


    if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
      return returnFirstNode;
    } // jump out, but not on the guard


    if (indexDiff && Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    } // focus above lock


    if (activeIndex <= firstNodeIndex) {
      return returnLastNode;
    } // focus below lock


    if (activeIndex > lastNodeIndex) {
      return returnFirstNode;
    } // index is inside tab order, but outside Lock


    if (indexDiff) {
      if (Math.abs(indexDiff) > 1) {
        return lastNodeInside;
      }

      return (cnt + lastNodeInside + indexDiff) % cnt;
    } // do nothing


    return undefined;
  };

  var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = null;
    leftEntries.filter(Boolean).forEach(function (entry) {
      topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
      rightEntries.filter(Boolean).forEach(function (subEntry) {
        var common = getCommonParent(activeElement, subEntry);

        if (common) {
          if (!topCommon || common.contains(topCommon)) {
            topCommon = common;
          } else {
            topCommon = getCommonParent(common, topCommon);
          }
        }
      });
    });
    return topCommon;
  };

  var allParentAutofocusables = function allParentAutofocusables(entries) {
    return entries.reduce(function (acc, node) {
      return acc.concat(parentAutofocusables(node));
    }, []);
  };

  var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
    var remap = new Map(); // no Set(dstNodes) for IE11 :(

    dstNodes.forEach(function (entity) {
      return remap.set(entity.node, entity);
    }); // remap to dstNodes

    return srcNodes.map(function (node) {
      return remap.get(node);
    }).filter(Boolean);
  };

  var getFocusMerge = function getFocusMerge(topNode, lastNode) {
    var activeElement = document && document.activeElement;
    var entries = getAllAffectedNodes(topNode).filter(notAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var innerElements = getTabbableNodes(entries).filter(function (_ref4) {
      var node = _ref4.node;
      return notAGuard(node);
    });

    if (!innerElements[0]) {
      innerElements = getAllTabbableNodes(entries).filter(function (_ref5) {
        var node = _ref5.node;
        return notAGuard(node);
      });

      if (!innerElements[0]) {
        return undefined;
      }
    }

    var outerNodes = getTabbableNodes([commonParent]).map(function (_ref6) {
      var node = _ref6.node;
      return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function (_ref7) {
      var node = _ref7.node;
      return node;
    });
    var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

    if (newId === undefined) {
      return newId;
    }

    return orderedInnerElements[newId];
  };

  var focusInFrame = function focusInFrame(frame) {
    return frame === document.activeElement;
  };

  var focusInsideIframe = function focusInsideIframe(topNode) {
    return !!arrayFind(toArray(topNode.querySelectorAll('iframe')), focusInFrame);
  };

  var focusInside = function focusInside(topNode) {
    var activeElement = document && document.activeElement;

    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
      return false;
    }

    return getAllAffectedNodes(topNode).reduce(function (result, node) {
      return result || node.contains(activeElement) || focusInsideIframe(node);
    }, false);
  };

  var focusIsHidden = function focusIsHidden() {
    return document && toArray(document.querySelectorAll('[' + FOCUS_ALLOW + ']')).some(function (node) {
      return node.contains(document.activeElement);
    });
  };

  var focusOn = function focusOn(target) {
    target.focus();

    if (target.contentWindow) {
      target.contentWindow.focus();
    }
  };

  var guardCount = 0;
  var lockDisabled = false;

  var setFocus = function setFocus(topNode, lastNode) {
    var focusable = getFocusMerge(topNode, lastNode);

    if (lockDisabled) {
      return;
    }

    if (focusable) {
      if (guardCount > 2) {
        // eslint-disable-next-line no-console
        console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
        lockDisabled = true;
        setTimeout(function () {
          lockDisabled = false;
        }, 1);
        return;
      }

      guardCount++;
      focusOn(focusable.node);
      guardCount--;
    }
  };

  var lastActiveTrap = 0;
  var lastActiveFocus = null;

  var focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
  };

  var isFreeFocus = function isFreeFocus() {
    return focusOnBody() || focusIsHidden();
  };

  var activateTrap = function activateTrap() {
    var result = false;

    if (lastActiveTrap) {
      var observed = lastActiveTrap;

      if (!isFreeFocus()) {
        if (observed && !focusInside(observed)) {
          result = setFocus(observed, lastActiveFocus);
        }

        lastActiveFocus = document.activeElement;
      }
    }

    return result;
  };

  var reducePropsToState = function reducePropsToState(propsList) {
    return propsList.filter(function (node) {
      return node;
    }).slice(-1)[0];
  };

  var handleStateChangeOnClient = function handleStateChangeOnClient(trap) {
    lastActiveTrap = trap;

    if (trap) {
      activateTrap();
    }
  };

  var instances = [];

  var emitChange = function emitChange(event) {
    if (handleStateChangeOnClient(reducePropsToState(instances))) {
      event && event.preventDefault();
      return true;
    }

    return false;
  };

  var attachHandler = function attachHandler() {
    document.addEventListener('focusin', emitChange);
  };

  var detachHandler = function detachHandler() {
    document.removeEventListener('focusin', emitChange);
  };

  var focusLock = {
    on: function on(domNode) {
      if (instances.length === 0) {
        attachHandler();
      }

      if (instances.indexOf(domNode) < 0) {
        instances.push(domNode);
        emitChange();
      }
    },
    off: function off(domNode) {
      instances = instances.filter(function (node) {
        return node !== domNode;
      });
      emitChange();

      if (instances.length === 0) {
        detachHandler();
      }
    }
  };
  var mAttr = "data-".concat(vl.ns, "modal"),
      mDressedAtt = "".concat(mAttr, "-dressed"),
      mClosable = "".concat(mAttr, "-closable"),
      mOpen = "".concat(mAttr, "-open"),
      mClose = "".concat(mAttr, "-close"),
      mFocusOnClose = "".concat(mAttr, "-focus-on-close"),
      mFocusId = "".concat(mAttr, "-focus-id"),
      mfocusLockDisabled = "".concat(mAttr, "-disable-focus-lock"),
      mOpenClass = "".concat(vl.ns, "modal-dialog--opened"),
      mFallbackBackdropClass = '.backdrop',
      mNoHTML5FallbackClass = "".concat(vl.ns, "modal-backdrop"),
      mNoHTML5FallbackClassHidden = "".concat(vl.ns, "modal-backdrop--hidden"),
      noOverflowClass = "".concat(vl.ns, "u-no-overflow");

  var Modal = /*#__PURE__*/function () {
    function Modal() {
      _classCallCheck(this, Modal);

      this.lastClickedToggle = null;
      this.activeElement = null;
    }

    _createClass(Modal, [{
      key: "__isFocusLockActive",
      value: function __isFocusLockActive(element) {
        return !element.hasAttribute(mfocusLockDisabled);
      }
    }, {
      key: "__lockFocus",
      value: function __lockFocus(element) {
        if (this.__isFocusLockActive(element)) {
          focusLock.on(element);
        }
      }
    }, {
      key: "__unlockFocus",
      value: function __unlockFocus(element) {
        if (this.__isFocusLockActive(element)) {
          focusLock.off(element);
        }
      }
    }, {
      key: "__handleFocus",
      value: function __handleFocus(element) {
        var closable = element.hasAttribute(mClosable);
        var focusOnClose = element.hasAttribute(mFocusOnClose);

        if (closable && focusOnClose) {
          document.getElementById(element.id + "-close-button").focus();
        } else if (mFocusId) {
          var focusId = element.getAttribute(mFocusId);
          var focusElement = element.querySelector("#".concat(focusId));

          if (focusElement) {
            focusElement.focus();
          }
        }
      }
    }, {
      key: "toggle",
      value: function toggle(element) {
        var forceClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var visible = element.hasAttribute('open') || vl.util.hasClass(element, mOpenClass);
        var html5El = element.tagName === 'dialog';

        if (visible || forceClose) {
          if (visible) {
            if (html5El) {
              element.close();
            } else {
              vl.util.removeClass(element, mOpenClass);
              var backdrop = document.querySelector(".".concat(mNoHTML5FallbackClass));

              if (backdrop) {
                // only hide backdrop when all modals are closed
                if (document.querySelectorAll(".".concat(mOpenClass)).length < 1) {
                  vl.util.addClass(backdrop, mNoHTML5FallbackClassHidden);
                } // set z-index of dialog


                var zBackdrop = document.defaultView.getComputedStyle(backdrop).getPropertyValue('z-index');
                backdrop.style.zIndex = Number(zBackdrop) - 1;
                element.style.zIndex = Number(zBackdrop);
              }
            }

            element.setAttribute('aria-hidden', true);
          }

          if (this.lastClickedToggle) {
            this.lastClickedToggle.focus();
          } else if (this.activeElement) {
            this.activeElement.focus();
          }

          vl.util.removeClass(document.body, noOverflowClass);

          this.__unlockFocus(element);
        } else {
          if (html5El) {
            element.showModal();
          } else {
            vl.util.addClass(element, mOpenClass);

            var _backdrop = document.querySelector(".".concat(mNoHTML5FallbackClass));

            if (_backdrop) {
              vl.util.removeClass(_backdrop, mNoHTML5FallbackClassHidden); // set z-index of dialog

              var _zBackdrop = document.defaultView.getComputedStyle(_backdrop).getPropertyValue('z-index');

              _backdrop.style.zIndex = Number(_zBackdrop) + 1;
              element.style.zIndex = Number(_zBackdrop) + 2;
            }

            this.activeElement = document.activeElement;
          }

          element.setAttribute('aria-hidden', false);
          vl.util.addClass(document.body, noOverflowClass);

          this.__lockFocus(element);

          this.__handleFocus(element);
        }
      }
    }, {
      key: "dress",
      value: function dress(element) {
        var linkedOpenTrigger,
            linkedClosedTrigger,
            closable = false,
            self = this;

        if (element.tagName === 'dialog') {
          // Register polyfill
          dialogPolyfill.registerDialog(element);
        } else {
          if (typeof document !== 'undefined') {
            var backdrop = document.querySelector(".".concat(mNoHTML5FallbackClass));

            if (!backdrop) {
              var backdropEl = document.createElement('div');
              vl.util.addClass(backdropEl, mNoHTML5FallbackClass);
              vl.util.addClass(backdropEl, mNoHTML5FallbackClassHidden);
              document.body.appendChild(backdropEl);
            }
          }
        } // Add bound attribute


        element.setAttribute(mDressedAtt, true); // Handle open/close

        linkedOpenTrigger = document.querySelectorAll("[".concat(mOpen, "=\"").concat(element.id, "\"]"));
        linkedClosedTrigger = element.querySelectorAll("[".concat(mClose, "]")); // See if closable (by esc or backdrop)

        closable = element.hasAttribute(mClosable);
        vl.util.each(linkedOpenTrigger, function (openTrigger) {
          openTrigger.addEventListener('click', function (event) {
            self.lastClickedToggle = this;

            if (!element.hasAttribute('open') || !vl.util.hasClass(element, mOpenClass)) {
              self.toggle(element);
            }

            event.preventDefault();
          });
        });
        vl.util.each(linkedClosedTrigger, function (closeTrigger) {
          closeTrigger.addEventListener('click', function () {
            if (element.hasAttribute('open') || vl.util.hasClass(element, mOpenClass)) {
              self.toggle(element);
            }
          });
        }); // If attribute closable is available

        if (closable) {
          // Make sure click outside of element closes modal
          document.addEventListener('click', function (event) {
            if (element.hasAttribute('open') || vl.util.hasClass(element, mOpenClass)) {
              var dialogBounds = element.getBoundingClientRect(),
                  isInDialog = event.clientY > dialogBounds.top && event.clientY < dialogBounds.top + dialogBounds.height && event.clientX > dialogBounds.left && event.clientX < dialogBounds.left + dialogBounds.width;

              if (!isInDialog && (event.target.tagName === 'DIALOG' || vl.util.hasClass(event.target, mFallbackBackdropClass) || vl.util.hasClass(event.target, mNoHTML5FallbackClass))) {
                self.toggle(element);
              }
            }
          });
          element.addEventListener('close', function () {
            self.toggle(element, true);
          });
        } else {
          element.addEventListener('keydown', function (event) {
            if (event.keyCode === 27) {
              event.preventDefault();
              event.stopPropagation();
            }
          });
        }
      }
    }, {
      key: "dressAll",
      value: function dressAll() {
        var _this = this;

        var elements = document.querySelectorAll("[".concat(mAttr, "]:not([").concat(mDressedAtt, "]):not([data-").concat(vl.ns, "js-dress=\"false\"])"));
        vl.util.each(elements, function (element) {
          _this.dress(element);
        });
      }
    }]);

    return Modal;
  }();

  if (!('modal' in vl)) {
    vl.modal = new Modal();
    vl.modal.dressAll();
  }

  return Modal;
});